import { render, staticRenderFns } from "./FullScreen.vue?vue&type=template&id=2b10d578&scoped=true&"
import script from "./FullScreen.vue?vue&type=script&lang=js&"
export * from "./FullScreen.vue?vue&type=script&lang=js&"
import style0 from "./FullScreen.vue?vue&type=style&index=0&id=2b10d578&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b10d578",
  null
  
)

export default component.exports